import { render, staticRenderFns } from "./Companyproportion.vue?vue&type=template&id=69d146d7&scoped=true&"
import script from "./Companyproportion.vue?vue&type=script&lang=js&"
export * from "./Companyproportion.vue?vue&type=script&lang=js&"
import style0 from "./Companyproportion.vue?vue&type=style&index=0&id=69d146d7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69d146d7",
  null
  
)

export default component.exports